var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M559.717 930.194a30.165 30.165 0 0 1-21.446-8.953l-5.635-5.692-88.715-335.47-335.548-88.735-5.722-5.721a30.177 30.177 0 0 1-8.324-26.927 30.175 30.175 0 0 1 17.532-22.067L887.844 96.38l-0.021 0.009c11.467-5.038 24.603-2.578 33.469 6.265 8.866 8.844 11.359 21.975 6.351 33.453L587.379 912.123c-4.059 9.206-12.339 15.752-22.172 17.567a30.196 30.196 0 0 1-5.49 0.504zM214.202 457.267l278.801 73.729 73.729 278.801 275.276-627.806-627.806 275.276zM911.959 151.32l-0.098 0.042a4.81 4.81 0 0 0 0.098-0.042z",
    fill: "#FFB100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIcon);
export default __webpack_public_path__ + "static/media/navigationIcon.e2348ecad4029cb785efdde56f9f00ce.svg";
export { ForwardRef as ReactComponent };